import { __decorate } from "tslib";
import { VuexModule, Module, Mutation, getModule } from 'vuex-module-decorators';
import store from '@blade/common/store';
let searchCenter = class searchCenter extends VuexModule {
    selectId = '';
    selectNumber = 0;
    zoneId = '';
    clickZoneId = '';
    mapUrl = '';
    featureList = [];
    attributeMaps = {};
    featureType = '';
    activeName = '';
    isLineHover = false;
    choseIndex = 0;
    animationDeviceId = '';
    isdevicedClick = false;
    selcetIndex = 0;
    isMap = false;
    updateMap(bool) {
        this.isMap = bool;
    }
    updateIsdevicedClick(bool) {
        this.isdevicedClick = bool;
    }
    updateSelcetIndex(id) {
        this.selcetIndex = id;
    }
    updateChoseIndex(index) {
        this.choseIndex = index;
    }
    updateAnimationDeviceId(id) {
        this.animationDeviceId = id;
    }
    updateSelectId(id) {
        this.selectId = id;
    }
    updateIsLineHover(bool) {
        this.isLineHover = bool;
    }
    updateSelectNumber(id) {
        this.selectNumber = id;
    }
    updateActiveName(str) {
        this.activeName = str;
    }
    updateZoneId(id) {
        this.zoneId = id;
    }
    updateClickZoneId(id) {
        this.clickZoneId = id;
    }
    updateMapurl(url) {
        this.mapUrl = url;
    }
    updateFeatureList(featureList) {
        this.featureList = featureList;
    }
    updateAttributeMaps(attributeMaps) {
        this.attributeMaps = attributeMaps;
    }
    updateFeatureType(type) {
        this.featureType = type;
    }
};
__decorate([
    Mutation
], searchCenter.prototype, "updateMap", null);
__decorate([
    Mutation
], searchCenter.prototype, "updateIsdevicedClick", null);
__decorate([
    Mutation
], searchCenter.prototype, "updateSelcetIndex", null);
__decorate([
    Mutation
], searchCenter.prototype, "updateChoseIndex", null);
__decorate([
    Mutation
], searchCenter.prototype, "updateAnimationDeviceId", null);
__decorate([
    Mutation
], searchCenter.prototype, "updateSelectId", null);
__decorate([
    Mutation
], searchCenter.prototype, "updateIsLineHover", null);
__decorate([
    Mutation
], searchCenter.prototype, "updateSelectNumber", null);
__decorate([
    Mutation
], searchCenter.prototype, "updateActiveName", null);
__decorate([
    Mutation
], searchCenter.prototype, "updateZoneId", null);
__decorate([
    Mutation
], searchCenter.prototype, "updateClickZoneId", null);
__decorate([
    Mutation
], searchCenter.prototype, "updateMapurl", null);
__decorate([
    Mutation
], searchCenter.prototype, "updateFeatureList", null);
__decorate([
    Mutation
], searchCenter.prototype, "updateAttributeMaps", null);
__decorate([
    Mutation
], searchCenter.prototype, "updateFeatureType", null);
searchCenter = __decorate([
    Module({ dynamic: true, store, namespaced: true, name: 'senseXplorer/searchCenter' })
], searchCenter);
export const searchCenterStore = getModule(searchCenter);
